<ng-container *ngIf="view$ | async as view">
  <div class="flex flex-col gap-3 border rounded-xl px-4 py-3 bg-base-white">
    <div class="flex flex-wrap items-start justify-between gap-2">
      <div class="flex flex-col">
        <p class="text-sm font-semibold text-gray-900">Payment split</p>
        <p class="text-xs text-gray-500">
          <ng-container *ngIf="view.currentVersion as current; else notSplit">
            Version {{ current.version }}
            <ng-container *ngIf="current.createdBy"> · by {{ current.createdBy }}</ng-container>
            · {{ current.created | date: 'medium' }}
          </ng-container>
          <ng-template #notSplit>Not split yet: save the split to prepare its payments.</ng-template>
        </p>
      </div>

      <button
        *ngIf="canManage"
        vs-button
        appearance="outline"
        size="sm"
        [disabled]="view.isLocked || !!hold"
        (click)="dialog.open(view.authorization, view.current)"
      >
        <vs-icon name="coins-swap-01"></vs-icon> Split payment
      </button>
    </div>

    <!-- Current shares -->
    <div class="flex flex-col divide-y">
      <ng-container
        *ngIf="view.currentVersion?.shares ?? (view.authorizedShare ? [view.authorizedShare] : []) as shares"
      >
        <div *ngFor="let share of shares" class="flex items-center justify-between gap-4 py-2 text-sm">
          <div class="flex items-center gap-2 min-w-0">
            <p class="text-gray-900 truncate">{{ share.payee }}</p>
            <vs-badge [theme]="share.kind === 'Repair shop' ? 'info' : 'default'">{{ share.kind }}</vs-badge>
          </div>
          <div class="flex items-center gap-3 shrink-0">
            <span class="text-xs text-gray-500">{{ share.percent }}%</span>
            <span class="font-semibold text-gray-900">
              {{ formatAmount(share.amount, view.authorization.currency) }}
            </span>

            <ng-container *ngIf="share.allocation as allocation">
              <vs-badge *ngIf="paymentBadge(allocation.paymentStatus) as badge" [theme]="badge.theme">
                {{ badge.text }}
              </vs-badge>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>

    <p *ngIf="canManage && view.isLocked" class="text-xs text-gray-500">
      The split can't change once a payment is prepared.
    </p>
    <p *ngIf="canManage && hold" class="text-xs text-gray-500">The split is locked. {{ heldBackMessage(hold) }}</p>

    <!-- Earlier versions, newest first -->
    <ng-container *ngIf="view.history.length">
      <button
        vs-button
        type="button"
        appearance="clear"
        size="xs"
        class="self-start"
        (click)="isHistoryShown = !isHistoryShown"
      >
        <vs-icon [name]="isHistoryShown ? 'chevron-up' : 'chevron-down'"></vs-icon>
        {{ isHistoryShown ? 'Hide' : 'Show' }} earlier versions ({{ view.history.length }})
      </button>

      <div *ngIf="isHistoryShown" class="flex flex-col gap-2">
        <div *ngFor="let version of view.history" class="flex items-start justify-between gap-4 text-sm">
          <div class="flex flex-col">
            <p class="text-gray-700">
              Version {{ version.version }}
              <span class="text-gray-500">
                <ng-container *ngIf="version.createdBy"> · by {{ version.createdBy }}</ng-container>
                · {{ version.created | date: 'mediumDate' }}
              </span>
            </p>
            <p class="text-xs text-gray-500">
              <ng-container *ngFor="let share of version.shares; let last = last">
                {{ share.payee }} {{ formatAmount(share.amount, view.authorization.currency) }}{{ last ? '' : ' · ' }}
              </ng-container>
            </p>
          </div>
          <vs-badge theme="default">Replaced</vs-badge>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>

<ws-claim-allocation-dialog #dialog [claim]="claim" (saved)="changed.emit()"></ws-claim-allocation-dialog>
